import { Map } from 'immutable';
import { connect } from '../../react-redux';
import { removeAlert } from '../../actions/alerts';
import Alert from '../../records/Alert';
import Alerts from './presenter';
var mapStateToProps = function mapStateToProps(state, props) {
  var alerts = state.get('alerts', Map());
  return {
    alerts: alerts.map(function (data) {
      return new Alert(data);
    }).valueSeq().toList().filter(function (alert) {
      return props.politeness === alert.politeness;
    })
  };
};
export default connect(mapStateToProps, {
  removeAlert: removeAlert
})(Alerts);